<template>
  <footer class="background-primary mt-5 text-white">
    <div class="row">
      <div class="col-10 offset-1">
        <div class="row align-items-center">
          <div class="col-xl-2 col-lg-3 col-md-4 d-none d-md-block px-5">
            <router-link v-bind:to="{ name: 'index' }">
              <img src="/static/images/logo.png" class="img-fluid" />
            </router-link>
          </div>
          <div class="col-xl-10 col-lg-9 col-md-8 col-sm-12">
            <h3 class="font-weight-bold">Kontak</h3>
            <div class="row">
              <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 Jakarta</h4>
                <p class="small">(021) 48679169</p>
              </div>
              <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 45</h4>
                <p class="small">(021) 8309364</p>
              </div>
             <!--<div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 PROGRAM SMP</h4>
                <p class="small">(0812) 84338055</p>
              </div> -->
              <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 DUTA</h4>
                <p class="small">(021) 8414613</p>
              </div>
              <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 FATMAWATI</h4>
                <p class="small">(021) 27654521</p>
              </div>
              <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 DEPOK</h4>
                <p class="small">(021) 77826423</p>
              </div>
	      <div class="col-auto">
                <h4 class="font-weight-bold mb-0">BTA 8 KELAPA GADING</h4>
                <p class="small">(021) 21698378</p>
              </div>
              <!--<div class="col-auto">
                                <h4 class="font-weight-bold mb-0">BTA 8 PASAR MINGGU</h4>
                                <p class="small">
                                    (021) 27872359
                                </p>
                            </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
footer {
  padding: 20px;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue